export default __webpack_public_path__ + "static/media/thanks_welcome_logo.dc6cc5d3.png";